module.exports = __webpack_public_path__ + "img/天气实况背景@2x.b6b49409.png";